var Instance, getAllPOI, getPOIByID, getSelectedPOI_ID, getSelectedUS_ID;

getSelectedUS_ID = function() {
  var j, len, selPOI, user_id;
  selPOI = [];
  for (j = 0, len = users_id.length; j < len; j++) {
    user_id = users_id[j];
    if (us_checked[user_id]) {
      selPOI.push(user_id);
    }
  }
  return selPOI;
};


/*
Return the ids of all the selected forms
 */

getSelectedPOI_ID = function() {
  var selPOI;
  selPOI = [];
  $(".ft:checked").each(function(i, elem) {
    return selPOI.push($(elem).val());
  });
  return selPOI;
};

getPOIByID = function(id) {
  return POI[id];
};


/*
    Single POI Instance
 */

Instance = function() {
  this.pages = [];
  this.locations = [];
  this.name = [];
  this.row_id1 = [];
  this.dates = [];
  this.editor_id = [];
  this.rows = [];
  this.questions = [];
  this.imageNo = [];
  this.loadedLocs = [];
  this.status = [];
  this.count = 0;
  this.old = [];
  this.coordinates = [];
  this.temp = [];
  this.ids = [];
  return this;
};

getAllPOI = function() {
  return _.pluck(formCollection.where({
    isChild: false
  }), "id");
};

//# sourceMappingURL=maps/classPOI.js.map
